import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { IVISAxios } from "../../Modules/Axios/IVISAxios";
import Box from "@mui/material/Box";
import moment from "moment";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import Tooltip from "@mui/material/Tooltip";
import Styled from "styled-components";

import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import { useRecoilValue } from "recoil";
import { authoritiesAtom } from "../../states/Atoms/AuthAtoms";
import BMW_LOGO from "../../img/logo/bmw-logo.png";
import MINI_LOGO from "../../img/logo/mini-logo.png";
import RollsRoyce_LOGO from "../../img/logo/Rolls-Royce-logo.png";
import { CRN_MAP } from "../../utils/crn-mapper";

const DataGridComponent = ({
  vehicleData,
  handleOpen,
  setVinNumber,
  pageSize,
  setSelectedRows,
}) => {
  const [test, setRefresher] = useState(null);
  const [selectionModel, setSelectionModel] = useState([]);
  const authState = useRecoilValue(authoritiesAtom);

  //환급신청서 다운로드
  const DownLoadREF = async (e, row) => {
    try {
      const { vin } = row;
      const type = row.type === "노후차" ? "aar" : "ar";
      const result = await IVISAxios.get(`/attached`, {
        params: { vin, type },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${vin}_환급신청서.pdf`);
      document.body.appendChild(link);
      link.click();

      console.log(result);
    } catch (e) {
      console.log(e);
    }
  };

  //반출신청서 다운로드
  const DonwnLoadDF = async (e, vin) => {
    try {
      const result = await IVISAxios.get(`/attached`, {
        params: {
          vin: vin,
          type: "ac",
        },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${vin}_반출신청서.pdf`);
      document.body.appendChild(link);
      link.click();

      console.log(result);
    } catch (e) {
      console.log(e);
    }
  };

  const downloadAgedCarPdf = async (vin) => {
    try {
      const result = await IVISAxios.get(`/attached`, {
        params: { vin, type: "aa" },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${vin}_노후차교체감면신청서.pdf`);
      document.body.appendChild(link);
      link.click();

      console.log(result);
    } catch (e) {
      console.log(e);
    }
  };

  //환급신청서 컨펌
  const ConfirmHandlerref = async (e, vin) => {
    try {
      const result = await IVISAxios.patch(
        "/pdfref",
        new URLSearchParams({
          vin: vin,
        })
      );

      setRefresher(new Date());
      if (result) {
        //업데이트
        const updateResult = await inquiryAttachedFiles(vin);
        if (updateResult) {
          vehicleData
            .filter((x) => x.vin === vin)[0]
            .attacheds.filter((x) => x.type === "ar")[0].confirmAt =
            updateResult["ar"].confirmAt;
          vehicleData
            .filter((x) => x.vin === vin)[0]
            .attacheds.filter((x) => x.type === "ar")[0].confirmBy =
            updateResult["ar"].confirmBy;
        }
      }
      console.log(result);
      console.log(result);
    } catch (e) {
      console.log(e);
    }
  };

  //반출신청서 컨펌
  const ConfirmHandlerdf = async (e, vin) => {
    try {
      const result = await IVISAxios.patch(
        "/pdfdfco",
        new URLSearchParams({
          vin: vin,
        })
      );
      setRefresher(new Date());
      if (result) {
        //업데이트
        const updateResult = await inquiryAttachedFiles(vin);
        if (updateResult) {
          vehicleData
            .filter((x) => x.vin === vin)[0]
            .attacheds.filter((x) => x.type === "ac")[0].confirmAt =
            updateResult["ac"].confirmAt;
          vehicleData
            .filter((x) => x.vin === vin)[0]
            .attacheds.filter((x) => x.type === "ac")[0].confirmBy =
            updateResult["ac"].confirmBy;
        }
      }
      console.log(result);
    } catch (e) {
      console.log(e);
    }
  };

  // 노후차 컨펌
  const confirmAgedCar = async (vin) => {
    try {
      const result = await IVISAxios.patch("/aged-vehicle/confirm", { vin });
      setRefresher(new Date());
      if (result) {
        //업데이트
        const updateResult = await inquiryAttachedFiles(vin);
        if (updateResult) {
          vehicleData
            .filter((x) => x.vin === vin)[0]
            .attacheds.filter((x) => x.type === "aa")[0].confirmAt =
            updateResult["aa"].confirmAt;
          vehicleData
            .filter((x) => x.vin === vin)[0]
            .attacheds.filter((x) => x.type === "aa")[0].confirmBy =
            updateResult["aa"].confirmBy;
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const inquiryAttachedFiles = async (vin) => {
    try {
      const result = await IVISAxios.get("/attached", {
        params: { vin: vin },
      });
      if (result.data.success) {
        return result.data.result;
      } else return null;
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  const clickHandler = (e) => {
    e.stopPropagation();
    setVinNumber(e.target.innerText);
    handleOpen();
  };

  //고정 헤더 2021-10-29
  const columns = [
    {
      field: "brand",
      headerName: "",
      width: 40,
      renderCell: (params) => (
        <>
          {params.value === "BMW" ? (
            <div className="width100 flex-row-center">
              <LogoSize src={BMW_LOGO} />
            </div>
          ) : params.value === "MINI" ? (
            <div className="width100 flex-row-center">
              <LogoSize src={MINI_LOGO} />
            </div>
          ) : params.value === "RollsRoyce" ? (
            <div className="width100 flex-row-center">
              <LogoSize src={RollsRoyce_LOGO} />
            </div>
          ) : null}
        </>
      ),
    },
    {
      field: "vin",
      headerName: "차대번호",
      width: 180,
      renderCell: (params) => (
        // <a href={`/search/${params.value}`}>{params.value}</a>
        <SpanPointer onClick={clickHandler}>{params.value}</SpanPointer>
      ),
    },
    {
      field: "type",
      headerName: "유형",
      width: 60,
    },
    {
      field: "createdAt",
      headerName: "신청",
      width: 80,
      renderCell: (params) => (
        <div>{renderDateByMoment(params.value, "MM/DD")}</div>
      ),
    },
    {
      field: "appliedAt",
      headerName: "접수",
      width: 80,
      renderCell: (params) => (
        <div>{renderDateByMoment(params.value, "MM/DD")}</div>
      ),
    },
    {
      field: "approvedAt",
      headerName: "승인",
      width: 80,
      renderCell: (params) => (
        <div>{renderDateByMoment(params.value, "MM/DD")}</div>
      ),
    },
    {
      field: "paidAt",
      headerName: "지급",
      width: 80,
      renderCell: (params) => (
        <div>{renderDateByMoment(params.value, "MM/DD")}</div>
      ),
    },
    {
      field: "crn",
      headerName: "딜러사",
      width: 70,

      renderCell: (params) => (
        <Box sx={{ flex: 1, textAlign: "center" }}>
          {CRN_MAP.get(params.value)}
        </Box>
      ),
    },
    {
      field: "deadLine",
      headerName: "마감기한",
      width: 110,
      renderCell: (params) =>
        params.value ? (
          <div>{moment(params.value).format("YYYY/MM/DD")}</div>
        ) : null,
    },
    {
      field: "totalRefund",
      headerName: "총 환급금",
      width: 110,
      renderCell: (params) => (
        <Box sx={{ flex: 1, textAlign: "right" }}>
          <span>{params.value?.toLocaleString()}</span>
        </Box>
      ),
    },
    {
      field: "PDF",
      headerName: "환급신청서",
      width: 100,
      renderCell: (params) => {
        const attached = params.row.attacheds;
        const filtered = attached
          ? attached.filter((x) => x.type === "ar" || x.type === "aar")
          : null;
        return attached &&
          attached.filter((x) => x.type === "ar" || x.type === "aar").length >
            0 ? (
          <Box
            sx={{ flex: 1, textAlign: "center" }}
            onClick={(e) => e.stopPropagation()}
          >
            <IconButton onClick={(e) => DownLoadREF(e, params.row)}>
              <DownloadIcon />
            </IconButton>
            {filtered[0].confirmAt ? (
              <Tooltip
                title={moment(filtered[0].confirmAt).format("YYYY/MM/DD HH:mm")}
              >
                <IconButton sx={{ color: "#0a0" }}>
                  <CheckIcon />
                </IconButton>
              </Tooltip>
            ) : (
              //  <Tooltip title={filtered[0].confirmAt}> g</Tooltip>

              <IconButton
                sx={{ color: "#ddd" }}
                onClick={(e) => ConfirmHandlerref(e, params.row.vin)}
                disabled={authState.includes("AONEBMW")}
              >
                <CheckIcon />
              </IconButton>
            )}
          </Box>
        ) : null;
      },
    },
    {
      field: "PDF2",
      headerName: "반출신청서",
      width: 100,
      renderCell: (params) => {
        const attached = params.row.attacheds;
        const filtered = attached
          ? attached.filter((x) => x.type === "ac")
          : null;
        return filtered && filtered.length > 0 ? (
          <Box
            sx={{ flex: 1, textAlign: "center" }}
            onClick={(e) => e.stopPropagation()}
          >
            <IconButton onClick={(e) => DonwnLoadDF(e, params.row.vin)}>
              <DownloadIcon />
            </IconButton>

            {filtered[0].confirmAt ? (
              <Tooltip
                title={moment(filtered[0].confirmAt).format("YYYY/MM/DD HH:mm")}
              >
                <IconButton sx={{ color: "#0a0" }}>
                  <CheckIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <IconButton
                sx={{ color: "#ddd" }}
                onClick={(e) => ConfirmHandlerdf(e, params.row.vin)}
                disabled={authState.includes("AONEBMW")}
              >
                <CheckIcon />
              </IconButton>
            )}
          </Box>
        ) : null;
      },
    },
    {
      field: "PDF3",
      headerName: "노후차",
      width: 100,
      renderCell: (params) => {
        const attached = params.row.attacheds;
        const filtered = attached
          ? attached.filter((x) => x.type === "aa")
          : null;
        return filtered && filtered.length > 0 ? (
          <Box sx={{ flex: 1, textAlign: "center" }}>
            <IconButton onClick={() => downloadAgedCarPdf(params.row.vin)}>
              <DownloadIcon />
            </IconButton>

            {filtered[0].confirmAt ? (
              <Tooltip
                title={moment(filtered[0].confirmAt).format("YYYY/MM/DD HH:mm")}
              >
                <IconButton sx={{ color: "#0a0" }}>
                  <CheckIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <IconButton
                sx={{ color: "#ddd" }}
                onClick={() => confirmAgedCar(params.row.vin)}
                disabled={authState.includes("AONEBMW")}
              >
                <CheckIcon />
              </IconButton>
            )}
          </Box>
        ) : null;
      },
    },
  ];
  const renderDateByMoment = (date, format) => {
    return date ? moment(date).format(format) : "";
  };

  return (
    <DataGrid
      autoHeight
      columns={columns}
      rows={vehicleData.map((row) => ({ ...row, id: row.vin }))}
      pageSize={pageSize}
      rowsPerPageOptions={[pageSize]}
      hideFooterSelectedRowCount
      hideFooterPagination={vehicleData.length === 0}
      checkboxSelection
      selectionModel={selectionModel}
      disableSelectionOnClick
      onSelectionModelChange={(ids) => {
        if (ids.length > 10) {
          alert("최대 10개까지 선택할 수 있습니다.");
          return; // 선택Model 안 바꿈
        }
        setSelectionModel(ids); // 선택된 ID 업데이트
        const selected = vehicleData.filter((row) => ids.includes(row.vin));
        setSelectedRows(selected);
      }}
      sx={{
        "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
          { display: "none" },
      }}
    />
  );
};
export default DataGridComponent;
const DatagridBox = Styled.div`
margin-top: 2vh
`;
const SpanPointer = Styled.span`
cursor: pointer
`;
const LogoSize = Styled.img`
  width: 50%;
  align-self: center;
`;
